<template>
  <app-data-editor
    :id="id"
    title="Редактирование номенклатуры"
    resource="nomenclatures"
    :elements="elements"
    add-message="Номенклатура добавлена"
    edit-message="Номенклатура изменена"
    @change="(payload) => isChanged = payload"
  />
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [
        [
          {
            title: "Наименование",
            name: "title",
            control: {
              type: "text",
              required: true,
              rules: [v => !!v || "Поле обязательно к заполнению"],
            },
            default: "",
          },
        ],
      ],
    };
  },
};
</script>
